import {useLocation, useNavigate} from "react-router-dom";
import {NavBar} from "antd-mobile";
import {useEffect, useState} from "react";
import {t} from "i18next";


const OrderDetail = () => {
    const DB = [
        {
            title: t('order_details_user_name'),
            key: 'userInfo.userName'
        },
        {
            title: t('order_details_user_mobile'),
            key: 'userInfo.mobile'
        },
        {
            title: t('order_details_id_number'),
            key: 'userInfo.idNum'
        },
        {
            title: t('order_details_address'),
            key: 'userInfo.address'
        },
        {
            title: t('create_order_email'),
            key: 'userInfo.email'
        },
        {
            title: t('create_order_staff'),
            key: 'userInfo.staff'
        },
        {
            title: t('order_details_emergency_contact'),
            key: 'userInfo.emergencyContact'
        },
        {
            title: t('order_details_emergency_mobile'),
            key: 'userInfo.emergencyMobile'
        },
        {
            title: t('order_details_product_name'),
            key: 'productInfo.model'
        },
        {
            title: t('order_details_product_serial_number'),
            key: 'productInfo.appleId'
        },
        {
            title: t('order_details_product_memory_size'),
            key: 'productInfo.memorySize'
        },
        {
            title: t('order_details_product_color'),
            key: 'productInfo.color'
        },
        {
            title: t('order_details_product_merchant'),
            key: 'productInfo.merchant'
        },
        {
            title: t('order_details_order_price'),
            key: 'orderInfo.price'
        },
        {
            title: t('order_details_down_payment'),
            key: 'orderInfo.downPayment'
        },
        {
            title: t('order_details_contract_date'),
            key: 'orderInfo.contractDate'
        },
        {
            title: t('order_details_order_type'),
            key: 'orderInfo.orderType'
        },
        {
            title: t('order_details_loan_periods'),
            key: 'orderInfo.periods'
        },
        {
            title: t('order_details_single_period_days'),
            key: 'orderInfo.singlePeriodDay'
        },
        {
            title: t('create_order_product_operator_lock'),
            key: 'productInfo.operatorLock'
        },
    ];
    const navigate = useNavigate();
    let location = useLocation();
    const [data, setData] = useState<any>({});
    const [list] = useState(DB)

    const toFlatObject = (obj: any) => {
        const result = {};
        const stack = [{ currentObj: obj, prefix: '' }];

        while (stack.length > 0) {
            // @ts-ignore
            const { currentObj, prefix } = stack.pop();

            for (const key in currentObj) {
                const newKey = prefix ? `${prefix}.${key}` : key;
                if (typeof currentObj[key] === 'object' && currentObj[key] !== null && !Array.isArray(currentObj[key])) {
                    stack.push({ currentObj: currentObj[key], prefix: newKey });
                } else {
                    if (newKey === 'productInfo.operatorLock') {
                        // @ts-ignore
                        result[newKey] = parseInt(currentObj[key]) === 1 ? 'YES' : 'NO';
                    } else {
                        // @ts-ignore
                        result[newKey] = currentObj[key];
                    }
                }
            }
        }

        return result;
    };

    useEffect(() => {
        const flatObject = toFlatObject(location.state);
        setData(flatObject);
    }, [location.state]);

    const back = () => {
        navigate(-1);
    };

    const _renderItemUI = (title: string, data: string, index: number) => {
        return <div key={index} style={{display: "flex", flexDirection: "row", padding: '5px 0', alignItems: "center", justifyContent: "space-between"}}>
            <span>{title}</span>
            <span>{data ? data : '--'}</span>
        </div>
    }

    return <div style={{display: "flex", flexDirection: "column", width: '100%',height: '100vh', backgroundColor: '#F5F6FA'}}>
        <NavBar style={{backgroundColor: '#FFF'}} onBack={back}>{t('order_details_title')}</NavBar>
        <div style={{margin: 10, padding: 10, backgroundColor: '#FFF', borderRadius: 12}}>
            {list.map((e: any, index: number) => {
                return _renderItemUI(e.title, data[e.key], index)
            })}
        </div>
    </div>
}
export default OrderDetail;
